import type { ComponentType, ReactNode } from "react";
import { DualCtaLiveProvider } from "@/contexts/DualCtaLiveContext";

export function DualCtaLiveShell({ children }: { children: ReactNode }) {
  return <DualCtaLiveProvider>{children}</DualCtaLiveProvider>;
}

export function withDualCtaLive<P extends object>(Component: ComponentType<P>) {
  return function DualCtaLiveWrapped(props: P) {
    return (
      <DualCtaLiveProvider>
        <Component {...props} />
      </DualCtaLiveProvider>
    );
  };
}
